import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import decode from 'jwt-decode';
import { t } from "i18next";
import AuthService from "../services/AuthService";

const SessionTimer = ({}) => {
    
    const authService = new AuthService();

    const expirationTimer = () => {
        try {            
            const decoded = decode(authService.getToken());
            let seconds = moment().diff(new Date(decoded.exp * 1000), 'seconds');
            return moment.utc(-seconds * 1000).format('mm:ss');
        } catch (err) {
            authService.logout();
            window.location.href = '/#/';
        }
    }

    const [timer, setTimer] = useState(expirationTimer());

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(expirationTimer());            
            if (!authService.loggedIn()) {
                authService.logout();
                window.location.href = '/#/';
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);


    

    return (        
        <div className='session-timer'>
            <span className='session-label' id='session-label'>
                {t('header.sessionTimer')}: <span className='session-time'>{timer}</span>
            </span>
        </div>
    );
};

SessionTimer.defaultProps = {
    
};


export default SessionTimer;